import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { TitleBar, IconCircle, IconClose, IconCheck, IconHelp} from '../../common/theme';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

const ContainerComp = ({pageState, parentState}) =>{

    const [refreshCompState, setRefreshCompState] = useState(true);    
    const [moduleData, setModuleData] = useState([]);   
    const [hasPretests, setHasPretests] = useState(false);
    const [hasPosttests, setHasPosttests] = useState(false);
    const [hasAssignments, setHasAssignments] = useState(false);

    const componentData = {
        moduleData, setModuleData,
        refreshCompState, setRefreshCompState
    }; 

    useEffect(() => {     
        if(!parentState.refreshCompState) return;
        
        // find the selected program assignments
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
        // get selected student assignments
        let students = program.students.filter(studRec => parentState.studentsSelected.indexOf(studRec.StudentID) > -1);

        // get an array of modules that have been assigned to the students
        let assignedModules = (students) ? students.reduce((acc,studentRec)=>{
            studentRec.assignedModules.map(moduleRec=>{
                acc[moduleRec] = (moduleRec in acc) ? acc[moduleRec]+1 : 1;
            });
            return acc;
        },{}) : {};

        // give students with no assignments full checkmarks for all the modules
        let studentsWithNoAssignments = students.filter((studentRec)=>studentRec.hasPretest === false && studentRec.hasPosttest === false && studentRec.hasAssignment === false);
        studentsWithNoAssignments.forEach(studRec=>{
            program.modules.forEach(moduleRec=>{
                assignedModules[moduleRec[0]] = (moduleRec[0] in assignedModules) ? assignedModules[moduleRec[0]]+1 : 1;
            });
        });

        let hasPretest = (students) ? students.filter((studentRec)=>studentRec.hasPretest === true).length > 0 : false;
        setHasPretests(hasPretest);
        let hasPosttest = (students) ? students.filter((studentRec)=>studentRec.hasPosttest === true).length > 0 : false;
        setHasPosttests(hasPosttest);
        let hasAssignment = (students) ? students.filter((studentRec)=>studentRec.hasAssignment === true).length > 0 : false;
        setHasAssignments(hasAssignment);

        // calculate which modules the selected students have assigned. None, all the selected students or some of the selected students
        let buildModuleData = program.modules.map(moduleRec=>{
            let assignType = (assignedModules[moduleRec[0]]) ? (assignedModules[moduleRec[0]] === students.length ) ? 'All' : 'Mixed' : 'None';
            // Matt get's confused with the green dots so hide them and make all checkmarks on when editing more then one student
            if(students.length > 1 && (assignType === 'Mixed' || assignType === 'None'))
                assignType = 'All';
            return {id:moduleRec[0], name: moduleRec[1], isAssigned: assignType!='None', assignType};
        });
        setModuleData(buildModuleData);
        
        parentState.setRefreshCompState(false);
    });
    //},[parentState.refreshCompState]);
    
    return <div><SideModuleTableComp assignments={{hasPretests,hasPosttests,hasAssignments}} pageState={pageState} componentData={componentData} parentState={parentState}/></div>;
};

const SideModuleTableComp = ({pageState, assignments,componentData, parentState}) => {

    const {hasPretests,hasPosttests,hasAssignments} = assignments;
    const [testableProgram,setTestableProgram] = useState(true);

    useEffect(()=>{
        // find the selected program assignments
        let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());

        if(program.id==='C4' || program.id==='C5' || program.id==='C6' ||
        program.id==='HLR2P' || program.id==='HLR3' || program.id==='HLR3P' || program.id==='HLR4' || program.id==='HLR4P' ||
        program.id==='LRP' || program.id==='LR1' || program.id==='LR2' || program.id==='LR3' ||
        program.id==='MMM' || program.id.startsWith('QUIZ') || program.id.startsWith('LESSON') || program.id.startsWith('COURSE')
        )
            setTestableProgram(false);

        // check is user made changes
        if(componentData.moduleData && parentState.studentsSelected.length === 1){
            let selectedOneStudent = program.students.filter(s=>s.StudentID===parentState.studentsSelected[0]);
            let studentHasNoAssignemt = (selectedOneStudent[0].assignedModules.length===0);
            if(!studentHasNoAssignemt){
                let madeChange = componentData.moduleData.filter( moduleRec => 
                    ((moduleRec.isAssigned && selectedOneStudent[0].assignedModules.filter(assignRec=>assignRec === moduleRec.id)).length===0) ||
                    ((!moduleRec.isAssigned && selectedOneStudent[0].assignedModules.filter(assignRec=>assignRec === moduleRec.id)).length > 0)
                ).length > 0;
                parentState.setMadeModuleChanges(madeChange);
            }
            else{
                let madeChange = false;
                if(componentData.moduleData.filter( moduleRec => moduleRec.isAssigned).length < componentData.moduleData.length)
                    madeChange = true;
                parentState.setMadeModuleChanges(madeChange);
            }
        }
        if(componentData.moduleData && parentState.studentsSelected.length > 1){
            let madeChange = componentData.moduleData.filter( moduleRec => !moduleRec.isAssigned).length > 0;
            parentState.setMadeModuleChanges(madeChange);
        }

    });

    const assignButtonClicked = (assign, type) => {
        let assignedModules = componentData.moduleData.reduce((acc,e)=>{
            if(e.isAssigned)
                acc += ';'+e.id; 
            return acc;
        },'').substr(1);
        //console.log('parentState',parentState);
        // only remove pretests, posttests or assignments when asked
        if(type==='remove' && assign !=='all'){
            let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
            //console.log('program1',program);
            let studentToRemove = []; 
            if(assign==='assignments')
                studentToRemove = program.students.filter(studRec=>studRec.hasAssignment && parentState.studentsSelected.find(studID=>studRec.StudentID===studID)).map(studRec=>studRec.StudentID);
            if(assign==='posttest')
                studentToRemove = program.students.filter(studRec=>studRec.hasPosttest && parentState.studentsSelected.find(studID=>studRec.StudentID===studID)).map(studRec=>studRec.StudentID);
            if(assign==='pretest')
                studentToRemove = program.students.filter(studRec=>studRec.hasPretest && parentState.studentsSelected.find(studID=>studRec.StudentID===studID)).map(studRec=>studRec.StudentID);

            parentState.setRequestState({progID:parentState.programSelectedID, students:studentToRemove, assign, type, assignedModules});
        }
        else if (type==='remove'){ // dont remove assignments that don't exist 
            let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
            let studentToRemove = []; 
            studentToRemove = program.students.filter(studRec=>(studRec.hasAssignment || studRec.hasPosttest || studRec.hasPretest) && parentState.studentsSelected.find(studID=>studRec.StudentID===studID)).map(studRec=>studRec.StudentID);
            parentState.setRequestState({progID:parentState.programSelectedID, students:studentToRemove, assign, type, assignedModules});
        }
        else{
            // console.log('else',{progID:parentState.programSelectedID, students:parentState.studentsSelected, assign, type, assignedModules});
            parentState.setRequestState({progID:parentState.programSelectedID, students:parentState.studentsSelected, assign, type, assignedModules});
        }
        parentState.setRefreshCompState(true);
    };

    const selectAll=()=>{
        let nextState = [...componentData.moduleData];
        nextState = nextState.map(e=>{e.isAssigned=true;return e;});
        componentData.setModuleData(nextState);
    };

    const unselectAll=()=>{
        let nextState = [...componentData.moduleData];
        nextState = nextState.map(e=>{e.isAssigned=false;return e;});
        componentData.setModuleData(nextState);
    };
    
    const hasModulesChecked=()=>{
        return componentData.moduleData.reduce((acc,e)=>{
            if(e.isAssigned)
                acc=true;
            return acc;
        },false);
    };
    const cancelAssignment=()=>{
        if(parentState.studentsSelected.length===1){
            let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
            let selectedOneStudent = program.students.filter(s=>s.StudentID===parentState.studentsSelected[0]);
            let studentHasNoAssignemt = (selectedOneStudent[0].assignedModules.length===0);
            if(!studentHasNoAssignemt){
                let program = pageState.processedProgramAssignments.find(assignRec=>assignRec.id.toUpperCase()===parentState.programSelectedID.toUpperCase());
                let selectedOneStudent = program.students.filter(s=>s.StudentID===parentState.studentsSelected[0]);
                let nextState = componentData.moduleData.map(moduleRec=>{
                    moduleRec.isAssigned = (selectedOneStudent[0].assignedModules.filter(assignRec=>assignRec === moduleRec.id).length>0);
                    return moduleRec;
                });        
                componentData.setModuleData(nextState);
            }else{
                let nextState = componentData.moduleData.map(moduleRec=>{
                    moduleRec.isAssigned = true;
                    return moduleRec;
                });        
                componentData.setModuleData(nextState);
            }
        }
        if(parentState.studentsSelected.length>1){
            let nextState = componentData.moduleData.map(moduleRec=>{
                moduleRec.isAssigned = true;
                return moduleRec;
            });        
            componentData.setModuleData(nextState);        
        }
    };
    return (
        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left'}} xs='8'>Module Name</Col>
                <Col xs='4'>Assigned<br/>
                    <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={selectAll}><IconCheck/></Button>&nbsp;
                    <Button style={{paddingRight:'0.5em',paddingLeft:'0.5em',paddingTop:'0.1em',paddingBottom:'0.1em'}} variant={'success'} onClick={unselectAll}><IconClose/></Button>
                </Col>
            </TitleBar>
            {/* {(hasPosttests || hasPretests) ? <><br/><Alert variant="danger"> Students that have pretests or post tests can not have assigned modules</Alert></>:<> */}
            <>
                <Row>
                    <Col style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                        {componentData.moduleData.map((moduleRec, i) => 
                            <ModuleRow key={i} componentData={componentData} moduleData={moduleRec} />
                        )}
                    </Col>
                </Row>
                <Row style={{marginTop:'10px'}}>
                <Button variant='success' disabled={!hasModulesChecked()} onClick={()=>assignButtonClicked('assignments','add')}>Save Assignment</Button> &nbsp; 
                {(parentState.madeModuleChanges) && <><Button variant='danger' data-toggle={'Press "Save Assignment" or "Cancel"\nbefore editing more students'} title={'Press "Save Assignment" or "Cancel"\nbefore editing more students'} onClick={()=>cancelAssignment()}>Cancel</Button></>}
                </Row>
            </>
            <br/>

        </Container>
    );
};

SideModuleTableComp.propTypes = {
    data: PropTypes.array
};

const CombinedIcon = ({type}) => <>
    {type === 'Mixed' && <IconCircle style={{color: 'green', fontSize: '10px' }}/>}
</>;

const ModuleRow = ({moduleData,componentData}) => {
    let {id, name, isAssigned, assignType} = moduleData;
    const [isChecked,setIsChecked] = useState(false);

    useEffect(()=>{
        setIsChecked(isAssigned);
    },[componentData]);

    const onChangeHandler=(event)=>{

        let nextState = [...componentData.moduleData];
        nextState.find(moduleRec=>moduleRec.id===id).isAssigned = event.target.checked;
        componentData.setModuleData(nextState);

        setIsChecked(event.target.checked);
    };

    return (
        <>
            <Row>
                <Col xs='8'> {name}</Col> 
                {/* <Col style={{textAlign: 'center'}} xs='4'> <CombinedIcon type={assignType}/> <input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isChecked}/> </Col> */}
                <Col style={{textAlign: 'center'}} xs='4'> <input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isChecked}/> </Col>
            </Row>
        </>
    );
};

export default ContainerComp;